// extracted by mini-css-extract-plugin
module.exports = {"challengeDetailsSkeleton_row":"ChallengeDetailsSkeleton_challengeDetailsSkeleton_row__1YHVq"};